import type { Branding } from './api.ts';


/** Rejects anything that is not a plain hex colour. */
export const isHexColour = (value: string): boolean =>
  /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(value);


/**
 * Apply branding as CSS custom properties on the document root.
 *
 * Validated before use: the colour arrives from a database row an admin
 * can edit, and it lands in a CSS context where escaping alone is not a
 * sufficient defence.
 */
export const applyBranding = (branding: Branding): void => {
  // The client's logo, not the client's palette.
  //
  // Recolouring the whole interface per tenant produced a different
  // looking product for every client, and any colour that is not ours
  // has to be luma checked, ramped and dark corrected before it is
  // safe on a button. Kestrelay teal everywhere is one product,
  // tested once, and the logo still says whose system it is.
  document.title = branding.identity?.product_name ?? branding.name;
};
